import { useCallback } from 'react';
import { hasFormMode } from '../modules/taboola-common-frontend-modules/forms/utils/hasFormMode';
import { useMultiLayerDrawerEnabled } from '../modules/taboola-common-frontend-modules/multi-layer-drawer/hooks/useMultiLayerDrawerEnabled';
import { useDrawerStack } from './queryParams/useDrawerStack';
import { useHistoryNavigate } from './useHistoryNavigate';

export const useNavigate = () => {
    const { push, replace } = useDrawerStack();
    const historyNavigate = useHistoryNavigate();
    const isMultiLayerDrawerEnabled = useMultiLayerDrawerEnabled();

    const navigate = useCallback(
        (path, options = {}) => {
            const { replaceForm, useDrawer = true } = options;

            if (useDrawer && isMultiLayerDrawerEnabled && hasFormMode(path)) {
                if (replaceForm) {
                    replace({ path });
                    return;
                }
                push({ path });
                return;
            }

            historyNavigate(path, options);
        },
        [isMultiLayerDrawerEnabled, historyNavigate, push, replace]
    );

    return navigate;
};
